import { useEffect, useRef, useState } from 'react';

type Props = {
  percent: number;
};

export const DocStateProgress = ({ percent }: Props) => {
  const [strokeDasharray, setStrokeDasharray] = useState<string | null>(null);
  const [strokeDashoffset, setStrokeDashoffset] = useState<string | null>(null);
  const ref = useRef<SVGCircleElement>(null);

  useEffect(() => {
    const circle = ref.current;
    if (!circle) return;
    const normalizePercentage = percent / 100;
    const radius = circle.r.baseVal.value;
    const circumference = radius * 2 * Math.PI;
    setStrokeDasharray(`${circumference} ${circumference}`);
    const offset = circumference - normalizePercentage * circumference;
    setStrokeDashoffset(`${offset}`);
  }, [percent]);

  return (
    <svg
      viewBox="0 0 36 36"
      style={{
        position: 'absolute',
        inset: 0,
        transform: 'rotate(-90deg)',
        transformOrigin: '50% 50%',
      }}
    >
      <defs>
        <linearGradient id="autopilot-progress-gradient" x1="0.5" y1="0" x2="0.5" y2="1">
          <stop offset="0%" stopColor="#ae8fff" />
          <stop offset="16%" stopColor="#84aaff" />
          <stop offset="48%" stopColor="#00d2f3" />
          <stop offset="65.33%" stopColor="#2cdbd9" />
          <stop offset="100%" stopColor="#4ded8d" />
        </linearGradient>
      </defs>

      <circle
        ref={ref}
        strokeWidth="2.5"
        r="16"
        cx="18"
        cy="18"
        style={{
          fill: 'transparent',
          stroke: 'url(#gradient)',
          strokeOpacity: 0.3,
        }}
      />

      {strokeDasharray && strokeDashoffset && (
        <circle
          strokeWidth="2.5"
          r="16"
          cx="18"
          cy="18"
          style={{
            fill: 'transparent',
            stroke: 'url(#autopilot-progress-gradient)',
            strokeDasharray,
            strokeDashoffset,
          }}
        />
      )}
    </svg>
  );
};
